__turbopack_context__.v({
  "applyTemplate": "SIUFZG_applyTemplate",
  "contact": "SIUFZG_contact",
  "contactContainer": "SIUFZG_contactContainer",
  "container": "SIUFZG_container",
  "eventDate": "SIUFZG_eventDate",
  "fakePaperTop": "SIUFZG_fakePaperTop",
  "title": "SIUFZG_title",
});
